import { Appointment } from '@medplum/fhirtypes';
import { appointmentHasOccurred } from '@bariendo/lib/pac-list-appointments';
import { isCancelledPaymentStatus, PaymentStatus } from '@bariendo/lib/payment-status';

/**
 * Which facts on the panel only the system may change now (`patient-profile.mdx` → Quick
 * information). Track and Package are what the patient was won on, so commission and revenue rest on
 * them; Location is where the procedure happened. A correction after that is an admin fix.
 */
export interface PanelLocks {
  /** Lead status reads Won; Track and Package are fixed. A reversed Won unlocks them again. */
  won: boolean;
  /** Lead status reads Cancelled, without waiting for Finance. */
  cancelled: boolean;
  /** Location is fixed. */
  procedureHappened: boolean;
}

export function panelLocks(status: PaymentStatus | undefined, procedures: Appointment[], now: Date): PanelLocks {
  return {
    won: status === PaymentStatus.WON,
    cancelled: isCancelledPaymentStatus(status),
    // The coverage card's procedure location locks on the same rule.
    procedureHappened: procedures.some((procedure) => appointmentHasOccurred(procedure, now)),
  };
}
